import * as actions from './actions';
import * as components from './components';
import * as containers from './containers';
import {print, printQueue} from './reducer';

export default {actions, components, containers, reducer: {print, printQueue}};



/** WEBPACK FOOTER **
 ** ./src/modules/print/index.js
 **/